import type { SelectOption } from "../../components/select-input";

export const MOVEMENT_SUB_TYPE_OPTIONS: SelectOption[] = [
  { label: "All subtypes", value: "all" },
  { label: "Deliver", value: "DELIVER" },
  { label: "Return", value: "RETURN" },
  { label: "Transfer", value: "TRANSFER" },
  { label: "Purchase", value: "PURCHASE" },
  { label: "Sell", value: "SELL" },
  { label: "Dispose", value: "DISPOSE" },
  { label: "Lost", value: "LOST" },
];

export const MOVEMENT_STATUS_OPTIONS: SelectOption[] = [
  { label: "All statuses", value: "all" },
  { label: "Draft", value: "DRAFT" },
  { label: "Initiated", value: "INITIATED" },
  { label: "Approved", value: "APPROVED" },
  { label: "Closed", value: "CLOSED" },
  { label: "Cancelled", value: "CANCELLED" },
];
